module.exports = __webpack_public_path__ + "img/baoxiao.7a7169fc.png";